function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M332.2 338.1H127c-5.5 0-10-4.5-10-10v-96c0-5.5 4.5-10 10-10h205.2c5.5 0 10 4.5 10 10v96c0 5.6-4.5 10-10 10z",
  fill: "#503fb2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M194.8 302.7h-.2l-3.2-.4c-7.1.7-29.4 2.4-53.4.1l-4.2.3c-.5 0-.9-.3-1.1-.8v-.2l-.3-5.6v-.2c-3.4-9-9.1-27.3-8.7-48.7l-1.1-3.9c-.1-.5.1-.9.6-.9h.2l5 .6c3.4-.5 8.5-1.3 14.5-1.7 10-.8 22.8-.9 35 1.5l5.3-.4c.5 0 .9.3 1.1.8v.2l.3 5.3c3.4 8.5 9.7 27.4 9.4 47.8l1.5 5.3c0 .5-.2.9-.7.9z",
  fill: "#ff2e57"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M191.4 302.3c-7.1.7-29.4 2.4-53.4.1l-4.2.3c-.5 0-.9-.3-1.1-.8v-.2l-.3-5.6v-.2c-3.4-9-9.1-27.3-8.7-48.7 8.2 34.7 18.1 47.2 18.1 47.2s21.4 8.5 49.6 7.9z",
  fill: "#ba2651"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M175.4 285.2l-8.2-15.3c-1-1.9-3-3-5.1-3-1.1 0-1.9.9-1.8 2l2 26.5 13.2.1 3.5-6.8-3.6-3.5z",
  fill: "#110b28"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#dfdeff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 229.6,
  cy: 366.9,
  rx: 163,
  ry: 21.7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 528.3,
  cy: 367.9,
  rx: 129.3,
  ry: 19
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 614.3,
  cy: 353.9,
  rx: 28.7,
  ry: 4.2
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M173.5 292.3l-8.3-15.3c-1-1.9-3-3-5.1-3-1.1 0-1.9.9-1.8 2l2 26.5 13.2.1 3.5-6.8-3.5-3.5z",
  fill: "#1f143e"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M222.6 329.6H106.4c-4.4 0-8-3.6-8-8v-11.1c0-4.4 3.6-8 8-8h116.1c4.4 0 8 3.6 8 8v11.1c.1 4.4-3.5 8-7.9 8z",
  fill: "#906dff"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 396.8,
  cy: 327,
  rx: 32.6,
  ry: 17.2,
  fill: "#dfdeff"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M412.1 325.6v-25.9h-31.8v25.9c0 2.4 1.5 4.7 4.6 6.5 6.2 3.6 16.3 3.6 22.5 0 3.1-1.8 4.7-4.1 4.7-6.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.1 299.8h-10.8v34.6c2.2-.4 4.3-1.2 6.1-2.2 3.1-1.8 4.7-4.1 4.7-6.5v-25.9z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M407.5 293.2c6.2 3.6 6.2 9.4-.1 13-6.2 3.6-16.3 3.6-22.5 0s-6.2-9.4.1-13c6.2-3.6 16.3-3.6 22.5 0z",
  fill: "#b7b2f9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M407.5 297.5c-6.2-3.6-16.3-3.6-22.5 0-2.2 1.3-3.6 2.8-4.2 4.4.7 1.6 2 3.1 4.2 4.3 6.2 3.6 16.3 3.6 22.5 0 2.2-1.3 3.6-2.8 4.2-4.4-.7-1.6-2.1-3.1-4.2-4.3z",
  fill: "#1f143e"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M405.3 291c-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.3 1.3-2.3 3.2-3 4.8l-.1-6.3c1.4-.5 4.9-1.8 6.8-3.7 1.2-1.2 1.9-2.2 2-3.1.2-.8 0-1.5-.7-2.2-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.3 1.3-2.3 3.2-3 4.7l-.1-5.1c1.3-.4 5-1.7 7-3.7 1.2-1.2 1.9-2.2 2-3.1.2-.8 0-1.5-.7-2.2-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.4 1.4-2.5 3.6-3.2 5.2l-.1-6.7c1.3-.4 5-1.7 7-3.7 1.2-1.2 1.9-2.2 2-3.1.2-.8 0-1.5-.7-2.2-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.4 1.4-2.5 3.5-3.2 5.1l-.1-6.6c1.3-.4 5-1.7 7-3.7 2.2-2.2 2.7-3.9 1.4-5.3-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.4 1.3-2.4 3.4-3.1 5.1l-.1-6.5c1.4-.4 5-1.7 7-3.7 1.2-1.2 1.9-2.2 2-3.1.2-.8 0-1.5-.7-2.2-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.3 1.3-2.4 3.4-3.1 5l-.1-5.6c1.4-.5 4.9-1.7 6.9-3.7 2.2-2.2 2.7-3.9 1.4-5.3-.6-.6-1.3-.8-2.2-.7-.9.2-1.9.8-3.1 2-1.3 1.3-2.4 3.3-3.1 4.9v-2.7c.7-1.5 2-4.7 2-7.3 0-1.7-.3-2.8-.8-3.6-.5-.7-1.2-1-2-1-.9 0-1.5.4-2 1.1-.5.8-.7 2-.7 3.6 0 2.6 1.5 5.8 2.2 7.2v2.7c-.7-1.6-1.8-3.5-3.2-4.8-2.3-2.1-4.1-2.5-5.3-1.2-1.3 1.3-.7 3.1 1.5 5.2 2 1.9 5.5 3.1 7 3.5l.1 5.4c-.7-1.6-1.8-3.5-3.1-4.7-2.3-2.1-4.1-2.5-5.3-1.2-1.3 1.3-.7 3.1 1.5 5.2 2 1.9 5.5 3 6.9 3.5l.1 6.3c-.7-1.6-1.8-3.4-3.1-4.7-2.3-2.1-4.1-2.5-5.3-1.2-1.3 1.3-.7 3.1 1.5 5.2 2 1.8 5.4 3 6.9 3.5l.1 6.2c-.7-1.5-1.8-3.4-3.1-4.6-2.3-2.1-4.1-2.5-5.3-1.2-1.3 1.3-.7 3.1 1.5 5.2 2 1.8 5.4 3 6.9 3.5l.1 6.1c-.7-1.5-1.8-3.3-3-4.5-2.3-2.1-4.1-2.5-5.3-1.2-1.3 1.3-.7 3.1 1.5 5.2 2 1.8 5.3 3 6.9 3.5l.1 5.5c-.7-1.6-1.9-3.7-3.3-5-1.2-1.1-2.3-1.8-3.2-1.9-.8-.1-1.5.1-2.1.7-1.3 1.3-.7 3.1 1.5 5.2 2.1 1.9 5.7 3.1 7.1 3.5l.1 6.5c-.7-1.6-1.8-3.6-3.2-4.9-2.3-2.1-4.1-2.5-5.3-1.2-1.3 1.3-.7 3.1 1.5 5.2 2 1.9 5.6 3.1 7 3.5v4.3c0 .2.1.4.2.5s.3.2.5.2a.68.68 0 0 0 .7-.7v-4.3c1.4-.5 4.9-1.8 6.9-3.7 2.8-1.6 3.3-3.4 2-4.7z",
  fill: "#ff2e57"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M357.7 368.2H103.4a4.95 4.95 0 0 1-5-5v-28.6a4.95 4.95 0 0 1 5-5h254.3a4.95 4.95 0 0 1 5 5v28.6a4.95 4.95 0 0 1-5 5z",
  fill: "#7448ff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M354.7 329.6H238.6c-4.4 0-8-3.6-8-8v-11.1c0-4.4 3.6-8 8-8h116.1c4.4 0 8 3.6 8 8v11.1c0 4.4-3.6 8-8 8z",
  fill: "#906dff"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  fill: "#7448ff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#B"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#B",
  x: 225.2
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M302.9 252.6h14.5c9.9 0 17.9-8 17.9-17.9v-54.9c0-13.9-11.3-25.2-25.2-25.2s-25.2 11.3-25.2 25.2v54.9c.1 9.9 8.1 17.9 18 17.9z",
  fill: "#bf352b"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M290.1 187.6v28.8l17.3-9.1-5.4-11.8z",
  fill: "#9b2313"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M175.4 294.8v-9.6l61.7-15.7 40.2-6.7 30.5 11.9-3.3 10.8-85.9 10.3z",
  fill: "#ea6f00"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M299.3 210c-1 .2-2 1.1-3 1.5-.3.1-1.1 0-1.4.2-4.8 2.3-8.1 6.3-9.8 11.5-2.6 8.1-6.1 18.2-7.4 19.9-2.2 2.8-10.8 14.8-10.8 14.8l6.7 4.2 16.3-15.9 4.9-24 4.5-12.2z",
  fill: "#eae6fe"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M284.9 277.8c-.8 0-48.6 1.4-48.6 1.4l-62.9 13v10.3h122.9c12.4 0 22.5-10.1 22.5-22.5l-33.9-2.2z",
  fill: "#fea800"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M290.8 218.8s-5.3 8.1-5.4 11 3.8 7.8-.4 14.6c-4.2 6.7-22.3 19.4-22.3 19.4s9.3 27.3 58.6 21.6c0 0-4.8-36.8 10.8-52.9s-4.1-21.3-4.1-21.3l-29.4-.9-3.6 1.5-4.2 7z",
  fill: "#1f143e"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M294.5 266.8v1.3l-30.4 17.5c-.2.1-.4.1-.6 0l-19.8-11.4a.55.55 0 0 1-.3-.5v-.9l2.2-1.4 3.4-1.9 1.1-.7 22.7-13.1h2.3l18.2 10.5 1.2.6z",
  fill: "#ba2651"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M245.6 272.7l17.9 10.3c.2.1.4.1.6 0l29.2-16.9-18.1-10.5-29.6 17.1z",
  fill: "#96857e"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M275.2 255.6l-29.6 17.1v-5.3l-1.1-.7v6.6l19 11c.2.1.4.1.6 0l30.4-17.5-19.3-11.2z",
  fill: "#ff2e57"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M275.2 250.4l-29.6 17.1v5.3l17.9 10.3c.2.1.4.1.6 0l29.2-16.9v-5.3l-18.1-10.5z",
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M294.5 258.9l-19.2-11.1-31.3 18c-.3.2-.3.5 0 .7l19.6 11.3c.2.1.4.1.6 0l30.4-17.5-.1-1.4z",
  fill: "#ff2e57"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M294.5 258.9l-30.4 17.5c-.2.1-.4.1-.6 0l-12.2-7-1.1-.7-5.1-3c-.8-.4-1.7.1-1.7 1v6.9l1.1-.3v-6.2c0-.1.2-.2.3-.2l.9.5 3.4 2 1.1.7 13.3 7.7c.2.1.4.1.6 0l30.4-17.5v-1.4z",
  fill: "#ba2651"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M245.6 267.4l.7.4v5.3l-.7-.4z",
  fill: "#fbc921"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M282.7 261.9c-5.1-3.1-6.2-3.9-8.9-4.3-2.7-.5-9.9 2.9-10.1 4.9s2.8 5.3 4.5 6.1c1.7.7 6.3-.6 6.3-.6s5.6 2.7 8.1 1c2-1.2 3.9-1.8 3.9-1.8l-1.4-3.5c.1-.1-1.9-.9-2.4-1.8z",
  fill: "#ffd6a9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M320.8 228.8c-3.9 13.3-5.1 26.7-5.2 28.8-22.1 1.3-25.1 3.3-25.1 3.3h-8.3c3.7 4.5 0 8.3 0 8.3l8.9.9c1.5 3 18.9 2.2 27 1.8 9.6-.4 10.9-5.5 10.9-5.5l10.3-35.2c1.4-4.6 1.2-14-6.6-17.3-3.4-.9-10 6.2-11.9 14.9z",
  fill: "#eae6fe"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M323.5 264.5s-5.3-5.9-7.9-6.9c5.3-.6 7.9 6.9 7.9 6.9zm-32.6-3.6s2.3 3.1.7 8c0 0 .5-5.1-2.3-8h1.6z",
  fill: "#b7b2f9"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M327.1 210v-15.5l3.5 17.6-3.2-1.1z",
  fill: "#9b2313"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M318.4 184.1c-.9 0-20.4 1.5-28.3-10.3v13.8c.1 7.9 6.5 14.2 14.4 14.2v6l-5.9 2.3c-1.1 8.2 16.8 14 23.2-2.8l-3.3-1.5V194c2.1 0 4.3-2.7 4.5-5.4s-1.1-5.4-4.6-4.5z",
  fill: "#ffd6a9"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M318.5 225.6c4.7 0 8.6-5.8 8.6-13.5v-17.5h-8.6v31z",
  fill: "#bf352b"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M304.5 201.8h4.8l-4.8 2.2zm14.1-11.8c.7-1.5.5-1.6-.3-1.7s.7-3.1 2.5-2 .2 5.5-1.6 5c-.9-.4-.7-1.1-.6-1.3z",
  fill: "#ffba7b"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M522.3 211l-3.6 13.8c-.3 1.3-.9 2.5-1.7 3.6-2.4 3.3-6.7 5.1-11 4.1l-3.1 12-16.1-6.4 1.4-5.3 23.9-30.1 10.2 8.3z",
  fill: "#ffd6a9"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M512.5 217.2c1.3-3.7 8.8-2.4 8.8-2.4l.7-2.5-2.8-1.5-5.1.7-2.9 4.1 1.3 1.6zm4.5 11.3c-2.4 3.3-6.7 5.1-11 4.1l-1 3.7h-.1l-2.7-5.1 2-3.6 2.6-2.4c-.7 4.5 7.5 6.8 10.2 3.3z",
  fill: "#ffba7b"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M519 212.5c-1.7-.1-3.2.5-4.4 1.5-.9.7-1.6 1.7-2 2.9l-1.7 4.8-1.4-3.2c-.3-.8-1-1.4-1.8-1.6-.9-.2-2 0-2.7.8-.2.2-.4.6-.5 1.1-.8 2.4.2 5 2.4 6.4-.3 1.2-1.2 2.4-2.3 3.6-4 3.9-9.7 5.5-15.2 4.3-.7-.1-1.2-.2-1.2-.2s-7.7-13.6-4-27.9c2.4-9.5 8.2-13.4 14.2-15 10.3-2.9 21.2 1 16.1-6 22.6 5.8 17.3 29.3 4.5 28.5z",
  fill: "#9b2313"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M523.3 214.9l-1.9-.5-.3 1.2 1.9.5c.2 0 .3.2.4.3l-13.3 3.1.5 1.1 12.7-3-.2.6c-.3 1.4-1.7 2.2-3.1 1.8l-.3 1.2c2 .5 4.1-.7 4.6-2.7l.4-1.5c.2-.8-.4-1.8-1.4-2.1z",
  fill: "#1e1e1e"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M519 212.5c-1.7-.1-3.2.5-4.4 1.5-8.1 5-31.8-18.7-17.5-23.5.8-.3 1.5-.5 2.3-.8 10-2.3 20 1 15-5.7 22.7 5.8 17.4 29.3 4.6 28.5z",
  fill: "#bf352b"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M620.8 351.4l-13.6 3c-1.3.4-2.7-.4-3.1-1.8l-1.6-5.8-.6-2.1c0-.1 0-.1-.1-.2v-.1s2.3-9.2 12.9-4.3c5 2.4 8.8 3.9 11.7 4.4 1.4.2 2.4 1.5 2.3 2.9-.3 2.2-1.1 2.7-7.9 4z",
  fill: "#1f143e"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M614.6 340.2L598.7 299c-3.7-11.4-10.1-12.6-17.6-9.5l-30.5 5.5-22.3-5.7 7.1 30.2 51.1-1.6 15.4 26.8h.9c4.9.2 8.5-.8 11.8-4.5z",
  fill: "#ff2e57"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M584 284.8l-17.6 15-5.9-2.3.7-.8z",
  fill: "#2525bf"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M587.1 289.3l-17.5 12.9s-3.3-1.4-2.9-1.7 20.4-11.2 20.4-11.2z",
  fill: "#ba2651"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M588.1 246.5l-39-22.3c-.7-.4-1.6-.6-2.4-.4-1.1.3-2.1.6-2.1 1.6l-.1 36.3 3.4 2c-1.1.5-35.4 17.2-35.4 17.3l-.1 1.4c0 .6.3 1.2.8 1.5l40 23.1c1.1.6 2.5.6 3.6 0l32.5-18.8c.3-.2.5-.6.5-.9l.1-37.5c0-1.5-.7-2.7-1.8-3.3z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M588.7 287l-44.3-25.3-.1-36.2c0-1 1.1-1.7 2-1.2l40.9 23.4c.9.5 1.4 1.5 1.4 2.5l.1 36.8z",
  fill: "#dfdeff"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M588.7 287l-44.3-25.5-31.3 18.1c-.9.5-.9 1.8 0 2.4l40.8 23.6a2.99 2.99 0 0 0 2.9 0l31.9-18.6z",
  fill: "#fff9ff"
});

var _ref49 = /*#__PURE__*/React.createElement("g", {
  fill: "#57438e"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -3.2,
  y: -1.9
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -9.7,
  y: -5.6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -13,
  y: -7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M557 276.5l2.2 1.3 2.2-1.3-2.2-1.3c-.9.6-1.4.8-2.2 1.3z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -19.5,
  y: -11.2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -22.8,
  y: -13.1
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -29.3,
  y: -16.8
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -29.3,
  y: -16.8
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -32.5,
  y: -18.7
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -3.1,
  y: 1.8
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -6.4,
  y: -0.1
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -6.4,
  y: -0.1
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -9.6,
  y: -2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  x: -6.4,
  y: -0.1
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -16.1,
  y: -5.7
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -19.4,
  y: -7.6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -25.9,
  y: -11.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -25.9,
  y: -11.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -29.1,
  y: -13.2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -35.7,
  y: -16.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.6 269l3.7 2.1 2.2-1.3-3.7-2.1c-.9.5-1.4.7-2.2 1.3zm31.2 21.4l3.7 2.1 2.2-1.3-3.7-2.1c-.9.6-1.3.8-2.2 1.3z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -9.5,
  y: 1.7
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  x: -3,
  y: 5.4
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -12.7,
  y: -0.2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -16,
  y: -2.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M554 281.9l2.2 1.3 2.2-1.3-2.2-1.3c-.9.6-1.4.8-2.2 1.3z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -22.5,
  y: -5.8
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -25.8,
  y: -7.7
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -32.3,
  y: -11.4
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -32.3,
  y: -11.4
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -35.5,
  y: -13.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  x: -32.3,
  y: -11.4
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -6.1,
  y: 7.2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -9.4,
  y: 5.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -15.9,
  y: 1.6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  x: -9.4,
  y: 5.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -19.1,
  y: -0.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -22.4,
  y: -2.2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -28.9,
  y: -5.9
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -28.9,
  y: -5.9
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -32.1,
  y: -7.8
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: -38.7,
  y: -11.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M533.1 273.6l3.6 2.1 2.2-1.3-3.6-2.1-2.2 1.3z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -41.9,
  y: -13.4
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -9.7,
  y: 9.2
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -12.9,
  y: 7.3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  x: -9.7,
  y: 9.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.5 280.1l18.5 10.6 2.2-1.3-18.5-10.6c-.9.6-1.3.8-2.2 1.3z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#E",
  x: -32.5,
  y: -3.9
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -42.2,
  y: -9.5
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#D",
  x: -45.5,
  y: -11.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.6 291.6l-15.2-8.7-8.7 5.3 15.2 8.8z"
}));

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M573.2 290.7l-16.2 7-2.7-1.4z",
  opacity: 0.25
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M497.7 229.5c5.5 3.9 15 11 23.3 17.3l19.9 54-54.9-47.6 1-14.1 10.7-9.6z",
  fill: "#fbc921"
});

var _ref52 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffd6a9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M568.4 292.3l-32.4 9.1a6.06 6.06 0 1 1-2.5-11.9l33-4.6 1.9 7.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.9 268.8l.9 1.7 7.7 15.2c1.5 3 .4 6.6-2.6 8.2l-.1.1c-3 1.5-6.7.3-8.2-2.7l-8.5-16.9c1-1 2.8-2.3 5-3.4 2.2-1.3 4.4-2 5.8-2.2z"
}));

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M510.2 256.7l16.4 17.8 5.6-5.5-8.8-19.4c-1.8-3.7-6.3-5.1-9.9-3.3-3.6 1.9-5.1 6.7-3.3 10.4z",
  fill: "#fea800"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M517 318.2s-2.7 9.1.2 12.4c.8.9 4.4 1.2 8.5.3 2.7-.6 5.6-2.2 8.3-2.6 7.8-1.1 12.5-5.3 15.7-9.6 6.9-9.2-5.6-6.4-13.8-3.5-8.7 3-18.9 3-18.9 3z",
  fill: "#1e2022"
});

var _ref55 = /*#__PURE__*/React.createElement("g", {
  fill: "#906dff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 287.5c22 12.1 42.3 18.3 46.3 38.8 0 .4-.2 20.5-35.3 20.5-56.8 0-70.1-58.3-70.1-107.4 0-24.8-26.1-28.8-39.6-10.9 8.8-12.1 19.9-20.1 31.1-20.1 38.5-.2 24.2 55.1 67.6 79.1z"
}));

var _ref56 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#F",
  fill: "#7448ff"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M589.3 326.2c0 .4-.2 20.5-35.3 20.5-56.8 0-70.1-58.3-70.1-107.4 0-24.8-26.1-28.8-39.6-10.9 8.8-12.1 19.9-20.1 31.1-20.1 38.5 0 24.2 55.2 67.6 79.2 22 12.1 42.3 18.2 46.3 38.7z",
  fill: "#906dff"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M443.2 229.9c.3-.5.7-1 1.1-1.5l-1.1 1.5z",
  fill: "#5652e5"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M568.4 292.3l5.4-1.9c1.9-1.3 4.4-7.6 3.3-8.9s-4.9-1.6-6.3-1.1c-1.5.5-4.3 4.6-4.3 4.6s-4.3 1.1-4.8 3.7c-.5 1.9-1.4 3.4-1.4 3.4l2.9 1.4c.1-.1 4.4-1.4 5.2-1.2z",
  fill: "#ffd6a9"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M508 222c-.3-1.4-.2-1.4.5-1.4.7.1 0-2.7-1.6-2.1-1.7.5-1.2 4.5.4 4.4.7-.1.7-.7.7-.9z",
  fill: "#ffba7b"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M318.2 285.6c-.6 2.2-1.4 4.2-2.6 6.1-9.9-.5-17.9-2.4-24-4.7-9.8-3.6-14.8-8-15.3-8.5 5.9 3.5 14.1 6.4 25.4 7.3 4.9.4 10.4.4 16.5-.2z",
  fill: "#ea6f00"
});

var _ref62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "B",
  d: "M130.5 254.5v43.1a4.95 4.95 0 0 1-5 5h-17.1a4.95 4.95 0 0 1-5-5v-43.1a4.95 4.95 0 0 1 5-5h17.1a4.95 4.95 0 0 1 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "C",
  d: "M576.5 287.7l2.2 1.3 2.2-1.3-2.2-1.3c-.9.6-1.3.8-2.2 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "D",
  d: "M573.2 285.9l2.2 1.3 2.2-1.3-2.2-1.3-2.2 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "E",
  d: "M566.7 282.1l2.2 1.3 2.2-1.3-2.2-1.3c-.8.6-1.3.8-2.2 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "F",
  d: "M589.3 326.2c.5 2.4.7 5 .7 7.8 0 13.5-11.8 40.9-75.7 38.7-75.9-2.6-88.9-47.5-88.9-85.3 0-20.5 7.1-42 17.8-57.4 0-.1.1-.1.1-.2.4-.5.7-1 1.1-1.5 13.5-17.9 39.6-13.9 39.6 10.9 0 49.2 13.4 107.4 70.1 107.4 35 .1 35.2-20 35.2-20.4z"
}));

var SvgNoAssignment = function SvgNoAssignment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAssignment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-assignment.eda39dd6.svg";
export { ForwardRef as ReactComponent };